var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3 3H4.95925C5.32827 3 5.51279 3 5.66127 3.06786C5.79213 3.12766 5.90302 3.22384 5.98072 3.34492C6.0689 3.48232 6.095 3.66498 6.14718 4.03029L6.85714 9M6.85714 9L8.43498 20.5971C8.63521 22.0688 8.73532 22.8046 9.08715 23.3585C9.39717 23.8466 9.84162 24.2347 10.367 24.4761C10.9633 24.75 11.7059 24.75 13.1912 24.75H26.028C27.4418 24.75 28.1487 24.75 28.7264 24.4956C29.2358 24.2713 29.6728 23.9098 29.9884 23.4513C30.3464 22.9314 30.4787 22.237 30.7432 20.8481L32.7287 10.4245C32.8218 9.93571 32.8683 9.6913 32.8009 9.50025C32.7417 9.33265 32.6249 9.19153 32.4713 9.10203C32.2963 9 32.0475 9 31.5499 9H6.85714ZM15 31.5C15 32.3284 14.3284 33 13.5 33C12.6716 33 12 32.3284 12 31.5C12 30.6716 12.6716 30 13.5 30C14.3284 30 15 30.6716 15 31.5ZM27 31.5C27 32.3284 26.3284 33 25.5 33C24.6716 33 24 32.3284 24 31.5C24 30.6716 24.6716 30 25.5 30C26.3284 30 27 30.6716 27 31.5Z",
    stroke: "#F0DE00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.c18df3d1da9c55f0fe51ea52df70f1c5.svg";
export { ForwardRef as ReactComponent };